import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAccountCardAPI } from '../../apis/account-card-api';
import { PaymentCardDeleteModalBody } from '../../components/payment/payment-card-delete-modal-body';
import { useErrorHandler } from '../../hooks/use-error-handler';
import { useStorage } from '../../hooks/use-storage';
import { useSwal } from '../../hooks/use-swal';
import { useAnalytics } from '../../utils/setup/analytics-setup';

function usePaymentCardDeleteModal() {
  const storage = useStorage();
  const { swal } = useSwal({ storage });
  const { deleteAccountCardFromRemote } = useAccountCardAPI();
  const { handleErrorOnModal } = useErrorHandler();
  const { t } = useTranslation();
  const { analyticsPageView } = useAnalytics();

  function didOpen() {
    analyticsPageView('Delete Payment Card');
  }

  async function show({ card, prepareOnPreConfirm }) {
    const result = await swal.fire({
      title: t('payment-card-delete-modal.title'),
      html: <PaymentCardDeleteModalBody card={card} />,
      icon: 'warning',
      didOpen,
      showConfirmButton: true,
      showLoaderOnConfirm: true,
      showCancelButton: true,
      confirmButtonText: t('delete'),
      cancelButtonText: t('cancel'),
      preConfirm: () => preConfirm({ card, prepareOnPreConfirm }),
    });

    return result;
  }

  async function preConfirm({ card, prepareOnPreConfirm }) {
    try {
      await deleteAccountCardFromRemote(card.id);
      await prepareOnPreConfirm?.call(this);
    } catch (error) {
      handleErrorOnModal(error);
      return false;
    }

    return true;
  }

  return {
    showPaymentCardDeleteModal: show,
  };
}

export { usePaymentCardDeleteModal };
